<template>
  <form @submit.prevent="save()">
    <div class="main-header">
      <h3>{{$t('admin.addaccount.new_account_role')}}</h3>
      <button type="submit">{{$t('global.save')}}</button>
    </div>
    <div class="form-field">
      <section v-for="(item, idx) in form" :class="{'inline':item.inline}" :key="idx">
        <span>{{item.name}}</span>
        <input v-if="item.type ==='text'" type="text" v-model="item.value" :placeholder="item.placeholder">
        <input v-if="item.type ==='password'" type="password" v-model="item.value">
        <select v-if="item.key==='roles'" v-model="item.value">
          <option v-for="option in roles" :value="option.value" :key="option.name">{{option.name}}</option>
        </select>
      </section>
    </div>
  </form>
</template>

<script>
  export default {
    data () {
      return {
        form:[
          {name:this.$t('admin.addaccount.user_name'),key:'username',value:'',type:'text'},
          {name:this.$t('admin.addaccount.password'),key:'password',value:'',type:'text',placeholder:''},
          {name:this.$t('admin.common.real_name'),key:'realname',value:'',type:'text'},
          // {name:'单位',key:'',value:'',type:'text',inline:true},
          // {name:'职位',key:'',value:'',type:'text'},
          {name:this.$t('admin.addaccount.email'),key:'email',value:'',type:'text',inline:true},
          {name:this.$t('admin.addaccount.phone_number'),key:'mobile',value:'',type:'text'},
          {name:this.$t('admin.addaccount.select_role_grouping'),key:'roles',value:''}
        ],
        roles:[],
        body:{}
      }
    },
    methods:{
      save () {
        this.form.forEach(val=>{
            this.body[val.key] = val.value
        })
        this.body.roles = [{id:this.body.roles}]
        this.$http.post('/ams/admin/save',JSON.stringify(this.body)).then(()=>{
          // window.alert(this.$t('global.save'))
          this.$notify({
            title: 'Success',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/ams/admin/account/list')
        }).catch(() => {
          this.$router.push('/ams/admin/account/list')
        })
      },
      getRoles () {
        return this.$http.get('/ams/role/list').then(res => {
          return (res.data.data || []).map(v => {
            return {
              name:v.name,
              value:v.id,
            }
          })
        })
      }
    },
    mounted() {
      this.getRoles().then(res=>this.roles = res).then(()=>{
        if (this.$route.name === 'account_edit' ) {
          this.$http.get('/ams/admin/detail',{params:{id:this.$route.params.id}}).then(res=>{
            this.body = res.data.data
            this.form.forEach(val=>{
              if (val.key === 'roles' && this.body.roles.length) {
                val.value = this.body.roles[0].id
              } else if (val.key === 'password') {
                val.placeholder = this.$t('admin.addaccount.set_new_password')
              } else{
                val.value = this.body[val.key]
              }
            })
          })
        }
      })
    }
  }
</script>
